// Users module

define('modules/Registration/Registration.Forms',[], function () {
    'use strict';

    // Forms definitions
    var forms = {
       'CustomRegistration': {
            Fields: [
                { 'Name': 'First Name', 'Field': '#register_first_name', 'Param': 'firstName', 'Type': 'Text' },
                { 'Name': 'Last Name', 'Field': '#register_last_name', 'Param': 'lastName', 'Type': 'Text' },
                { 'Name': 'Email', 'Field': '#register_email', 'Param': 'email', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                { 'Name': 'Confirm Email', 'Field': '#register_email2', 'Param': 'emailConfirm', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                { 'Name': 'Company Name', 'Field': '#register_company_name', 'Param': 'companyName', 'Type': 'Text' },
                { 'Name': 'Attn', 'Field': '#register_attn', 'Param': 'attn', 'Type': 'Text' },
                { 'Name': 'Address Line 1', 'Field': '#register_address_line1', 'Param': 'addressLine1', 'Type': 'Text' },
                { 'Name': 'Address Line 2', 'Field': '#register_address_line2', 'Param': 'addressLine2', 'Type': 'Text' , 'Optional': true },
                { 'Name': 'Suite', 'Field': '#register_suite', 'Param': 'suite', 'Type': 'Text','Optional': true },
                { 'Name': 'City', 'Field': '#register_city', 'Param': 'city', 'Type': 'Text' },
                { 'Name': 'State', 'Field': '#register_state', 'Param': 'state', 'Type': 'Select' },
                { 'Name': 'Zip', 'Field': '#register_zip', 'Param': 'zip', 'Type': 'Text' },
                { 'Name': 'Phone', 'Field': '#register_phone', 'Param': 'phone', 'Type': 'Text', "Validators": [{ "Type": 'Phone' }] },
                { 'Name': 'Interested in', 'Field': '#register_interestedIn', 'Param': 'interestedIn', 'Type': 'Textarea', 'Optional': true },
                { 'Name': 'Terms and Conditions agreement', 'Field': '#register_emailListOptIn', 'Param': 'emailListOptIn', 'Type': 'Checkbox' },
            ],
            Validate: true
        }
    };

    return forms;
});
